import {testIdProps} from '@github-ui/test-id-props'
import {Label} from '@primer/react'
import {clsx} from 'clsx'

import styles from './add-break-button.module.css'

interface AddBreakButtonProps {
  onClick: () => void
  /**
   * The hover target of the first Insert Break button can interfere with the
   * click target of buttons in the header (like `Add Iteration`), so this component
   * provides a way to turn that padding into a margin for that button.
   * */
  removeTopPadding: boolean
}

/**
 * Button to insert a break between two iterations. Intended to be placed directly between
 * iteration rows in the table.
 */
export function AddBreakButton({onClick, removeTopPadding}: AddBreakButtonProps) {
  return (
    <div className={styles.ButtonContainer}>
      <div className={clsx(styles.Button, removeTopPadding && styles.withoutTopPadding)}>
        <Label
          onClick={onClick}
          as="button"
          type="button"
          className={styles.Label}
          {...testIdProps('add-break-button')}
        >
          Insert break
        </Label>
      </div>
    </div>
  )
}

try{ AddBreakButton.displayName ||= 'AddBreakButton' } catch {}